var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "left-sidebar-prompt-contianer" },
    [
      _c("TextArea", {
        staticClass: "w-100 styled-text-area",
        attrs: {
          aiCustom: true,
          "border-class": "br-4",
          label: _vm.promptPlaceholder,
          "max-characters": 4000,
          rows: "4",
          isRowDynamic: _vm.isRowDynamic,
          value: _vm.currentJob.getActiveStageJob().settings.prompt,
          name: "prompt",
          type: "text",
          disabled: true,
        },
        model: {
          value: _vm.currentJob.getActiveStageJob().settings.prompt,
          callback: function ($$v) {
            _vm.$set(_vm.currentJob.getActiveStageJob().settings, "prompt", $$v)
          },
          expression: "currentJob.getActiveStageJob().settings.prompt",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }